<template>
  <div class="flex flex-1 flex-col">
    <MCol :size="6">
      <FlotoFormItemReadOnly :label="$tc('module')">
        <FlotoDropdownPicker
          v-model="ticketModuleName"
          as-input
          :options="ticketModuleOptions"
        />
      </FlotoFormItemReadOnly>
    </MCol>
    <MDivider />
    <TicketSelectionList
      v-if="ticketModuleName && canShowList"
      :key="ticketModuleName"
      :selectable="selectable"
      :searchable="searchable"
      :module-name="ticketModuleName"
      :fetch-fn="fetchTicketFn"
      v-bind="$attrs"
      @selection-change="handleSelectionChange"
    />
    <FlotoLoadError
      v-else
      size="small"
      :use-margin-top="false"
      authorization-error
    />
  </div>
</template>

<script>
import TicketSelectionList from '@components/item-selection-list/ticket-list'
import { searchTicketsApi } from '@modules/ticket/ticket-api'
import { LicenseComputed } from '@state/modules/license'
export default {
  name: 'TicketSelectionContainer',
  components: { TicketSelectionList },
  props: {
    sourceModuleName: { type: String, required: true },
    fetchFn: { type: Function, default: undefined },
    selectable: { type: Boolean, default: false },
    searchable: { type: Boolean, default: false },
    hiddenColumns: {
      type: Array,
      default() {
        return []
      },
    },
    excludeItemsById: {
      type: Array,
      default() {
        return []
      },
    },
    defaultSelectedItemIds: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      ticketModuleName: this.$constants.REQUEST,
    }
  },
  computed: {
    ...LicenseComputed,
    canShowList() {
      const availableOptions = this.ticketModuleOptions.filter(
        (option) => option.disabled === false
      )
      return !!availableOptions.length
    },
    ticketModuleOptions() {
      return [
        {
          text: this.$tc(this.$constants.REQUEST),
          key: this.$constants.REQUEST,
          disabled:
            this.availableModulesInLicense.indexOf(this.$constants.REQUEST) ===
            -1,
        },
        {
          text: this.$tc(this.$constants.CHANGE),
          key: this.$constants.CHANGE,
          disabled:
            this.availableModulesInLicense.indexOf(this.$constants.CHANGE) ===
            -1,
        },
      ]
    },
  },
  watch: {
    ticketModuleName(newValue, preValue) {
      if (newValue !== preValue) {
        this.$emit('selection-change', [])
        this.$emit('ticket-sub-module-change', newValue)
      }
    },
  },
  created() {
    this.$emit('ticket-sub-module-change', this.ticketModuleName)
  },
  methods: {
    fetchTicketFn(module, criterias, limit, offset) {
      if (this.fetchFn) {
        return this.fetchFn(module, criterias, limit, offset)
      } else {
        return searchTicketsApi(this.ticketModuleName, criterias, limit, offset)
      }
    },
    handleChangeModule(value) {
      this.ticketModuleName = value.key
    },
    handleSelectionChange(items) {
      this.$emit('selection-change', items)
      this.$emit('ticket-sub-module-change', this.ticketModuleName)
    },
  },
}
</script>
